var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgProjects = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 17",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10.667 3.167h.666A2.667 2.667 0 0 1 14 5.833V12.5a2.667 2.667 0 0 1-2.667 2.667H4.667A2.667 2.667 0 0 1 2 12.5V5.833a2.667 2.667 0 0 1 2.667-2.666h.666m5.334 0c0 .736-.597 1.333-1.334 1.333H6.667a1.333 1.333 0 0 1-1.334-1.333m5.334 0c0-.737-.597-1.334-1.334-1.334H6.667c-.737 0-1.334.597-1.334 1.334m2.667 4h2.667M8 9.833h2.667M8 12.5h2.667",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.333 7.167a.667.667 0 1 1-1.333 0 .667.667 0 0 1 1.333 0ZM6.333 9.833a.667.667 0 1 1-1.333 0 .667.667 0 0 1 1.333 0ZM6.333 12.5A.667.667 0 1 1 5 12.5a.667.667 0 0 1 1.333 0Z",
  fill: "currentColor"
})));
export default SvgProjects;